<template>
    <div>
        <b-card style="width: 100%; margin: 0px; padding: 0px;" no-body>
            <b-alert show>DAMAGE ORDER # {{id}} (Status: {{statusText}})</b-alert>
            
            <!-- Show loading state -->
            <div v-if="loading">
                <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="false">
                </loading>
            </div>
            
            <!-- Show error state -->
            <b-alert v-else-if="products.length === 0 && !loading" show variant="warning">
                Unable to load products. Please check if location is properly set.
            </b-alert>
            
            <!-- Show normal content when products are available -->
            <span v-else>
                <b-card-text class="d-flex flex-column flex-lg-row">
                    <b-card-text :disabled="shouldDisableFields" style="display: inline-block; vertical-align: top;">
                        <span :disabled="shouldDisableFields" v-if="products.length > 0">
                            <vue-simple-suggest
                                :disabled="shouldDisableFields"
                                v-model="product_search_keyword"
                                display-attribute="product_name"
                                value-attribute="damaged_item_id"
                                :max-suggestions="200"
                                :list="products"
                                :filter-by-query="true"
                                @select="add_item"
                                :filter="filter_products"
                                ref="product_sku"
                                style="margin-bottom: 10px; font-size: 16px; font-family: monospace; border: 1px solid black;"
                                class="input-field"
                            >
                                <div slot="misc-item-above" slot-scope="{ suggestions, query }">
                                    <div v-if="suggestions.length === 0 && query" class="suggestion-item">
                                        No damaged products found
                                    </div>
                                </div>
                                <div slot="suggestion-item" slot-scope="{ suggestion, autocomplete }">
                                    <div style="display: flex; align-items: center; padding: 5px 0;">
                                        <!-- Show first damage image if available -->
                                        <div v-if="suggestion.damage_images && suggestion.damage_images.length > 0" 
                                             style="margin-right: 10px; flex-shrink: 0;">
                                            <img 
                                                :src="suggestion.damage_images[0].image_url" 
                                                :alt="suggestion.damage_images[0].image_alt_text || suggestion.product_name"
                                                style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;"
                                                @error="handleImageError"
                                            />
                                        </div>
                                        <div style="flex-grow: 1;">
                                            <div style="font-weight: bold;">{{ suggestion.product_name }}</div>
                                            <div style="font-size: 12px; ">SKU: {{ suggestion.product_sku }}</div>
                                            <div style="font-size: 11px; ">
                                                Damage ID: {{ suggestion.damaged_item_id }} | 
                                                Type: {{ suggestion.damage_type }} | 
                                                Grade: {{ suggestion.damage_grade }}
                                            </div>
                                            <div style="font-size: 11px;">
                                                Price: ${{ (suggestion.wholesale_price || 0).toFixed(2) }} | 
                                                Cubes: {{ suggestion.cubes || 0 }}
                                            </div>
                                            <div v-if="suggestion.damage_images && suggestion.damage_images.length > 0" 
                                                 style="font-size: 11px; ">
                                                {{ suggestion.damage_images.length }} damage image(s) available
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </vue-simple-suggest>
                        </span>
                    </b-card-text>

                    <b-card-text style="display: inline-block; vertical-align: top;" class="ml-0 ml-lg-2">
                        <div v-if="items.length > 0">
                            <b-button variant="success" @click="save_damage_order_items">SAVE</b-button>
                        </div>
                        <div v-else>
                            <b-button variant="warning" @click="close_it">CANCEL</b-button>
                        </div>
                    </b-card-text>
                </b-card-text>

                <b-card-text>
                    <b-card-text v-if="items.length > 0" class="diver">
                        <table class="text-monospace" style="width: 100%;">
                            <thead>
                                <tr>
                                    <td class="srr" style="width: 80px;">Damage ID</td>
                                    <td class="srr" style="width: 100px;">PRODUCT SKU</td>
                                    <td class="srr" style="width: 200px;">DESCRIPTION</td>
                                    <td class="srr" style="width: 70px;" v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)">WHLSL</td>
                                    <td class="srr" style="width: 50px;">QTY ORD</td>
                                    <td class="srr" style="width: 50px;">SCH QTY</td>
                                    <td class="srr" style="width: 50px;">RCV QTY</td>
                                    <td class="srr" style="width: 100px;">ITEM STATUS</td>
                                    <td class="srr" style="width: 100px;">DEL STATUS</td>
                                    <td class="srr" style="width: 50px;">Cubes</td>
                                    <td class="srr" style="width: 180px;">ITEM LOC</td>
                                    <td class="srr" style="width: 300px;">AVAILABILITY</td>
                                    <td class="srr" style="width: 180px;">STAGING LOC</td>
                                    <td class="srr" style="width: 180px;">DROP LOC</td>
                                    <td class="srr" style="width: 150px;">DAMAGE TYPE</td>
                                    <td class="srr" style="width: 150px;">DAMAGE GRADE</td>
                                    <td class="srr" style="width: 150px;">SCHEDULE DATE</td>
                                    <td class="srr" style="width: 150px;">RECEIVED DATE</td>
                                    <td class="srr" style="width: 100px;" v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)">TOTAL</td>
                                    <td class="srr" style="width: 100px;">COMMENTS</td>
                                    <td class="srr" style="width: 100px;">DAMAGE DESC</td>
                                    <td class="srr" style="width: 100px;">PICTURE</td>
                                    <td class="srr" style="width: 80px;" v-if="read_only != true">ACTION</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item,idx in items" v-bind:key="idx" :style="getRowStyle(item)">
                                    <td class="srrv">{{item.damaged_item_id}}</td>
                                    <td class="srrv">{{item.product_sku}}</td>
                                    <td class="srrv">{{item.product_name}}</td>
                                    <td class="srrv" v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)">
                                        <b-form-input
                                            v-model="item.original_price"
                                            size="sm"
                                            type="number"
                                            step="0.01"
                                            style="font-size: 11px;"
                                            :disabled="isItemDisabled(item)"
                                        ></b-form-input>
                                    </td>
                                    <td class="srrv">
                                        <b-form-input
                                            v-model="item.quantity"
                                            size="sm"
                                            type="number"
                                            style="font-size: 11px;"
                                            :disabled="isItemDisabled(item)"
                                            @input="onQuantityInput(item)"
                                        ></b-form-input>
                                    </td>
                                    <td class="srrv">
                                        <b-form-input
                                            v-model="item.quantity_scheduled"
                                            size="sm"
                                            type="number"
                                            style="font-size: 11px;"
                                            :min="0"
                                            :max="item.quantity"
                                            :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item)"
                                            @keydown="preventInvalidEntry($event, item)"
                                            @input="onScheduledQuantityInput(item)"
                                            @blur="validateScheduledQuantity(item)"
                                        ></b-form-input>
                                    </td>
                                    <td class="srrv">
                                        <b-form-input
                                            v-model="item.quantity_received"
                                            size="sm"
                                            type="number"
                                            style="font-size: 11px;"
                                            :min="0"
                                            :max="item.quantity"
                                            :disabled="isItemDisabled(item)"
                                            @keydown="preventInvalidEntry($event, item)"
                                            @change="validateQuantity(item)"
                                        ></b-form-input>
                                    </td>
                                    <td class="srrv">
                                        <b-form-select
                                            :options="getStatusOptions(item)"
                                            v-model="item.status"
                                            size="sm"
                                            style="font-size: 11px;"
                                            :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item)"
                                            @change="handleStatusChange(item)"
                                            :state="getStatusState(item)"
                                            required
                                        ></b-form-select>
                                    </td>
                                    <td class="srrv">
                                        <b-form-select
                                            :options="delivery_statuses"
                                            v-model="item.delivery_status"
                                            size="sm"
                                            style="font-size: 11px;"
                                            :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item)"
                                            required
                                        ></b-form-select>
                                    </td>
                                    <td class="srrv">
                                        {{
                                            ((item.cubes || 0.0) * (item.quantity || 0.0)).toFixed(2)
                                        }}
                                    </td>
                                    <td class="srrv">
                                        <template v-if="item.quantity > 0">
                                            <b-form-select
                                                v-model="item.source_locsub"
                                                :options="sourceLocationOptions"
                                                size="sm"
                                                style="font-size: 11px;"
                                                :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item)"
                                            ></b-form-select>
                                        </template>
                                        <template v-else>
                                            Enter Qty to see locations
                                        </template>
                                    </td>
                                    <td class="srrv">
                                        <table class="table-sm availability-table">
                                            <tr>
                                                <th style="width: 50px;">STOCK</th>
                                                <th style="width: 50px;">RESERVED</th>
                                                <th style="width: 50px;">AVAILABLE</th>
                                            </tr>
                                            <tr>
                                                <td v-if="typeof item.in_stock === 'undefined'">Loading...</td>
                                                <td v-else>{{ item.in_stock }}</td>

                                                <td v-if="typeof item.reserved === 'undefined'">Loading...</td>
                                                <td v-else>{{ item.reserved }}</td>

                                                <td v-if="typeof item.available === 'undefined'">Loading...</td>
                                                <td v-else>{{ item.available }}</td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td class="srrv">
                                        <template v-if="item.quantity > 0">
                                            <b-form-select
                                                v-model="item.staging_location"
                                                :options="stagingLocationOptions"
                                                size="sm"
                                                style="font-size: 11px;"
                                                :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item)"
                                            ></b-form-select>
                                        </template>
                                        <template v-else>
                                            Enter Qty to see locations
                                        </template>
                                    </td>
                                    <td class="srrv">
                                        <b-form-select
                                            v-model="item.drop_location"
                                            :options="dropLocationOptions"
                                            size="sm"
                                            style="font-size: 11px;"
                                            :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item)"
                                        ></b-form-select>
                                    </td>
                                    <td class="srrv">
                                        <b-form-select
                                            :options="damageTypes"
                                            v-model="item.damage_type"
                                            size="sm"
                                            style="font-size: 11px;"
                                            :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item)"
                                        ></b-form-select>
                                    </td>
                                    <td class="srrv">
                                        <b-form-select
                                            :options="damageGrades"
                                            v-model="item.damage_grade"
                                            size="sm"
                                            style="font-size: 11px;"
                                            :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item)"
                                        ></b-form-select>
                                    </td>
                                    <td class="srrv">
                                        <div style="display: flex; align-items: center; position: relative;">
                                            <date-picker
                                                v-model="item.schedule_date"
                                                :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item)"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px; font-family: roboto; position: relative;"
                                                @change="onScheduleDateChange(item, $event)"
                                            ></date-picker>
                                            <b-badge
                                                v-if="item.has_external_schedule_date"
                                                variant="warning"
                                                style="position: absolute; top: -8px; right: -8px; z-index: 10; font-size: 9px; padding: 2px 4px;"
                                                v-b-tooltip.hover title="Date applied from main order"
                                            >
                                                ETA
                                            </b-badge>
                                        </div>
                                    </td>
                                    <td class="srrv">
                                        <div v-b-tooltip.hover title="">
                                            <date-picker
                                                v-model="item.received_date"
                                                :disabled="shouldDisableFields || isItemDisabled(item) || item.status !== 3"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                :disabled-date="disableFutureDates"
                                                style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px; font-family: roboto;"
                                                @change="onReceivedDateChange(item, $event)"
                                            ></date-picker>
                                        </div>
                                    </td>
                                    <td class="srrv" v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)">
                                        {{
                                            ((item.original_price || 0.0) * (item.quantity || 0.0)).toFixed(2)
                                        }}
                                    </td>
                                    <td class="srrv">
                                        <b-form-input
                                            v-model="item.comments"
                                            size="sm"
                                            type="text"
                                            style="font-size: 11px;"
                                            :disabled="isItemDisabled(item)"
                                        ></b-form-input>
                                    </td>
                                    <td class="srrv">
                                        <b-form-input
                                            v-model="item.damage_description"
                                            size="sm"
                                            type="text"
                                            style="font-size: 11px;"
                                            :disabled="isItemDisabled(item)"
                                            placeholder="Describe the damage..."
                                        ></b-form-input>
                                    </td>
                                    <td class="srrv">
                                        <div style="display: flex; flex-direction: column; align-items: center;">
                                            <!-- Show existing damage images -->
                                            <div v-if="item.existing_damage_images && item.existing_damage_images.length > 0" 
                                                 style="margin-bottom: 5px;">
                                                <div style="font-size: 9px; color: #666; margin-bottom: 2px;">Existing Damage:</div>
                                                <div style="display: flex; gap: 2px; flex-wrap: wrap; justify-content: center;">
                                                    <img
                                                        v-for="(img, imgIdx) in item.existing_damage_images"
                                                        :key="imgIdx"
                                                        :src="img.image_url"
                                                        :alt="img.image_alt_text"
                                                        @error="handleImageError"
                                                        style="width: 30px; height: 30px; object-fit: cover; border-radius: 3px; cursor: pointer;"
                                                        @click="showExistingImagePreview(img, item)"
                                                        class="img-thumbnail"
                                                    />
                                                </div>
                                            </div>
                                            
                                            <!-- Upload new images section -->
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    @change="handleImageUpload($event, item, idx)"
                                                    style="display: none;"
                                                    :ref="'fileInput-' + idx"
                                                    :disabled="isItemDisabled(item)"
                                                    multiple
                                                >
                                                <b-button
                                                    v-if="!item.images || item.images.length === 0"
                                                    size="sm"
                                                    variant="outline-primary"
                                                    @click="$refs['fileInput-' + idx][0].click()"
                                                    :disabled="isItemDisabled(item)"
                                                >
                                                    Upload New
                                                </b-button>
                                                <div v-else style="position: relative;">
                                                    <img
                                                        :src="getImageSrc(item.images[0])"
                                                        style="max-width: 80px; max-height: 60px; cursor: pointer;"
                                                        @click="showImagePreview(item)"
                                                        class="img-thumbnail"
                                                    >
                                                    <b-button
                                                        variant="danger"
                                                        size="xs"
                                                        @click="removeImage(item, idx)"
                                                        style="position: absolute; top: -10px; right: -10px; padding: 2px 5px;"
                                                        :disabled="isItemDisabled(item)"
                                                    >
                                                        ×
                                                    </b-button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="srrv" v-if="read_only != true">
                                        <b-button size="sm" style="font-size: 14px;" variant="danger" 
                                            @click="remove_item(item)" 
                                            v-b-tooltip.hover title="DELETE ITEM" 
                                            :disabled="shouldDisableFields || isItemDisabled(item)">
                                            <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                        </b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-text>
                    <b-card-text v-else>
                        <b-alert show variant="primary">NO ITEMS ADDED TO THIS DAMAGE ORDER YET.</b-alert>
                    </b-card-text>
                </b-card-text>
            </span>
        </b-card>

        <!-- Damage Order History Section -->
        <b-card v-if="id" style="margin: 0px; margin-top: 10px; padding: 0px;" no-body>
            <b-alert show>DAMAGE ORDER HISTORY</b-alert>

            <div v-if="damageOrderHistory.length > 0" class="diver">
                <b-card-text>
                    <table style="width: 100%;" class="text-monospace">
                        <thead>
                            <tr>
                                <td class="srr" style="width: 100px;">DATE</td>
                                <td class="srr" style="width: 100px;">SKU</td>
                                <td class="srr" style="width: 200px;">DESCRIPTION</td>
                                <td class="srr" style="width: 60px;">QTY</td>
                                <td class="srr" style="width: 100px;">DAMAGE TYPE</td>
                                <td class="srr" style="width: 100px;">DAMAGE GRADE</td>
                                <td class="srr" style="width: 100px;">STATUS</td>
                                <td class="srr" style="width: 100px;">SOURCE LOC</td>
                                <td class="srr" style="width: 100px;">CHANGED BY</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="historyItem, idx in damageOrderHistory" :key="idx">
                                <td class="srrv">{{ historyItem.change_date }}</td>
                                <td class="srrv">{{ historyItem.product_sku }}</td>
                                <td class="srrv">{{ historyItem.item_description }}</td>
                                <td class="srrv">{{ historyItem.quantity_damaged }}</td>
                                <td class="srrv">{{ historyItem.damage_type }}</td>
                                <td class="srrv">{{ historyItem.damage_grade }}</td>
                                <td class="srrv">{{ historyItem.status }}</td>
                                <td class="srrv">{{ historyItem.source_location || historyItem.source_locsub }}</td>
                                <td class="srrv">{{ historyItem.changed_by }}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card-text>
            </div>

            <div v-else>
                <div v-if="historyLoading">
                    <loading
                        :active="true"
                        :can-cancel="false"
                        :is-full-page="false">
                    </loading>
                </div>
                <div v-else>
                    <b-card-text class="srrv">NO HISTORY FOR THIS DAMAGE ORDER YET</b-card-text>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
    import moment from 'moment'
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import VueSimpleSuggest from 'vue-simple-suggest'
    import mappings from '@/utilities/mappings'
    import 'vue-simple-suggest/dist/styles.css'

    export default {
        name: "DamageOrderModal",
        props: ["viewdata"],
        components: { Loading, DatePicker, VueSimpleSuggest },
        data: function(){
            return {
                packet: {},
                id: null,
                read_only: false,
                order_status: null,
                loading: false,
                external_schedule_date: null,
                external_status: null,
                status_mapping: {
                    1: "ORDERED",
                    2: "SCHEDULED",
                    3: "PARTIAL",
                    4: "RECEIVED",
                    5: "COMPLETED",
                    6: "ARCHIVED"
                },
                defaultItemLocation: null,
                defaultStagingLocation: null,
                defaultDropLocation: null,
                orderingLocationName: null,
                selling_location:null,
                sellingLocationName: null,
                delivery_statuses: mappings.states,
                items: [],
                products: [],
                product_search_keyword: '',
                schedule_date: null,
                damageTypes: [
                    { value: 'physical', text: 'Physical Damage' },
                    { value: 'cosmetic', text: 'Cosmetic Damage' },
                    { value: 'functional', text: 'Functional Damage' },
                    { value: 'water', text: 'Water Damage' },
                    { value: 'shipping', text: 'Shipping Damage' },
                    { value: 'manufacturing', text: 'Manufacturing Defect' },
                    { value: 'other', text: 'Other' }
                ],
                damageGrades: [
                    { value: 'minor', text: 'Minor' },
                    { value: 'moderate', text: 'Moderate' },
                    { value: 'severe', text: 'Severe' },
                    { value: 'total', text: 'Total Loss' }
                ],
                itemStatuses: [
                    { value: 'ordered', text: 'ORDERED' },
                    { value: 'scheduled', text: 'SCHEDULED' },
                    { value: 'partial', text: 'PARTIAL' },
                    { value: 'completed', text: 'COMPLETED' },
                    { value: 'archived', text: 'ARCHIVED' },
                ],
                damageOrderHistory: [],
                historyLoading: false,
                location_id: null,
                sourceLocationOptions: [],
                stagingLocationOptions: [],
                dropLocationOptions: []
            }
        },
        methods: {
            isItemDisabled(item) {
                return item.status === 'disposed' || item.status === 'resold' || item.status === 'received';
            },
            getRowStyle(item) {
                if (item.status === 'disposed' || item.status === 'resold') {
                    return {
                        backgroundColor: '#f8f9fa',
                        opacity: '0.7'
                    };
                }
                return {};
            },
            getStatusOptions(item) {
                return [
                 { value: 'ordered', text: 'ORDERED' },
                    { value: 'scheduled', text: 'SCHEDULED' },
                    { value: 'partial', text: 'PARTIAL' },
                        { value: 'received', text: 'RECEIVED' },
                    { value: 'completed', text: 'COMPLETED' },
                    { value: 'archived', text: 'ARCHIVED' },
                ];
            },
            
            // SIMPLIFIED: Get damages sublocation directly
            getDamagesSublocation(locationId, locationName = '') {
                console.log('Looking for damages sublocation for:', { locationId, locationName });
                
                // First, check if we have locsubs data
                if (!this.packet.locsubs || this.packet.locsubs.length === 0) {
                    console.log('No locsubs data available');
                    // Return a default format
                    return {
                        value: `${locationId}|DAMAGES`,
                        text: `${locationName || 'Location'} DAMAGES`
                    };
                }
                
                // Convert locationId to string for comparison
                const locationIdStr = locationId.toString();
                
                // Look for damages sublocation for this specific location
                const damagesSublocation = this.packet.locsubs.find(loc => {
                    if (!loc.value) return false;
                    
                    // Split the value to get location ID part
                    const parts = loc.value.split('|');
                    if (parts.length < 1) return false;
                    
                    const locIdPart = parts[0];
                    const locName = (loc.text || '').toLowerCase();
                    
                    // Check if location ID matches AND name contains "damages"
                    return locIdPart === locationIdStr && locName.includes('damages');
                });
                
                if (damagesSublocation) {
                    console.log('Found damages sublocation:', damagesSublocation);
                    return {
                        value: damagesSublocation.value,
                        text: damagesSublocation.text || `${locationName} DAMAGES`
                    };
                }
                
                // If not found, search for any damages sublocation to understand the format
                const anyDamages = this.packet.locsubs.find(loc => {
                    const locName = (loc.text || '').toLowerCase();
                    return locName.includes('damages');
                });
                
                if (anyDamages) {
                    console.log('Found generic damages format:', anyDamages);
                    // Use the same format but with our location ID
                    const parts = anyDamages.value.split('|');
                    const suffix = parts.length > 1 ? parts[1] : 'DAMAGES';
                    return {
                        value: `${locationId}|${suffix}`,
                        text: `${locationName} ${suffix}`
                    };
                }
                
                // Default fallback
                console.log('Using default damages sublocation');
                return {
                    value: `${locationId}|DAMAGES`,
                    text: `${locationName || 'Location'} DAMAGES`
                };
            },
            
            setDefaultLocations() {
                console.log('=== SETTING DEFAULT LOCATIONS ===');
                console.log('Viewdata:', this.viewdata);
                
                if (!this.viewdata.location_id || !this.viewdata.selling_location) {
                    console.warn("Missing location information for default locations");
                    return;
                }

                const orderingLocationId = this.viewdata.location_id;
                const sellingLocationId = this.viewdata.selling_location;
                
                this.orderingLocationName = this.viewdata.ordering_location_name;
                this.sellingLocationName = this.viewdata.selling_location_name;
                
                console.log('Location Information:', {
                    orderingId: orderingLocationId,
                    orderingName: this.orderingLocationName,
                    sellingId: sellingLocationId,
                    sellingName: this.sellingLocationName
                });
                
                // 1. ITEM LOCATION (SOURCE) = Selling Location Damages
                const itemLocation = this.getDamagesSublocation(sellingLocationId, this.sellingLocationName);
                this.defaultItemLocation = itemLocation.value;
                
                // 2. STAGING LOCATION = Mecca Shipping Damages (ID: 47)
                const stagingLocation = this.getDamagesSublocation(47, 'MECCA SHIPPING');
                this.defaultStagingLocation = stagingLocation.value;
                
                // 3. DROP LOCATION = Ordering Location Damages
                const dropLocation = this.getDamagesSublocation(orderingLocationId, this.orderingLocationName);
                this.defaultDropLocation = dropLocation.value;
                
                console.log('Default locations calculated:', {
                    itemLocation: this.defaultItemLocation,
                    stagingLocation: this.defaultStagingLocation,
                    dropLocation: this.defaultDropLocation
                });
                
                // Now build the dropdown options
                this.buildLocationOptions();
            },
            
            buildLocationOptions() {
                console.log('=== BUILDING LOCATION OPTIONS ===');
                
                // Reset options
                this.sourceLocationOptions = [];
                this.stagingLocationOptions = [];
                this.dropLocationOptions = [];
                
                // 1. SOURCE LOCATION OPTIONS (Item Location)
                // Should default to Selling Location Damages
                if (this.defaultItemLocation) {
                    this.sourceLocationOptions.push({
                        value: this.defaultItemLocation,
                        text: `${this.sellingLocationName || 'Selling Location'} DAMAGES`
                    });
                }
                
                // Add other available locations from locsubs (excluding damages for source)
                if (this.packet.locsubs && this.packet.locsubs.length > 0) {
                    this.packet.locsubs.forEach(loc => {
                        const locName = (loc.text || '').toLowerCase();
                        // Don't add damages locations to source (except our default)
                        if (!locName.includes('damages') || loc.value === this.defaultItemLocation) {
                            // Don't add duplicates
                            if (!this.sourceLocationOptions.some(opt => opt.value === loc.value)) {
                                this.sourceLocationOptions.push({
                                    value: loc.value,
                                    text: loc.text || loc.value
                                });
                            }
                        }
                    });
                }
                
                // 2. STAGING LOCATION OPTIONS
                // Should default to Mecca Shipping Damages
                if (this.defaultStagingLocation) {
                    this.stagingLocationOptions.push({
                        value: this.defaultStagingLocation,
                        text: 'MECCA SHIPPING DAMAGES'
                    });
                }
                
                // Add staging/shipping locations from locsubs
                if (this.packet.locsubs && this.packet.locsubs.length > 0) {
                    this.packet.locsubs.forEach(loc => {
                        const locName = (loc.text || '').toLowerCase();
                        if (locName.includes('staging') || locName.includes('shipping')) {
                            // Don't add duplicates
                            if (!this.stagingLocationOptions.some(opt => opt.value === loc.value)) {
                                this.stagingLocationOptions.push({
                                    value: loc.value,
                                    text: loc.text || loc.value
                                });
                            }
                        }
                    });
                }
                
                // 3. DROP LOCATION OPTIONS
                // Should default to Ordering Location Damages
                if (this.defaultDropLocation) {
                    this.dropLocationOptions.push({
                        value: this.defaultDropLocation,
                        text: `${this.orderingLocationName || 'Ordering Location'} DAMAGES`
                    });
                }
                
                // Add damages locations from locsubs
                if (this.packet.locsubs && this.packet.locsubs.length > 0) {
                    this.packet.locsubs.forEach(loc => {
                        const locName = (loc.text || '').toLowerCase();
                        if (locName.includes('damages')) {
                            // Don't add duplicates
                            if (!this.dropLocationOptions.some(opt => opt.value === loc.value)) {
                                this.dropLocationOptions.push({
                                    value: loc.value,
                                    text: loc.text || loc.value
                                });
                            }
                        }
                    });
                }
                
                // If no options, add at least the defaults
                if (this.sourceLocationOptions.length === 0 && this.defaultItemLocation) {
                    this.sourceLocationOptions.push({
                        value: this.defaultItemLocation,
                        text: `${this.sellingLocationName || 'Selling Location'} DAMAGES`
                    });
                }
                
                if (this.stagingLocationOptions.length === 0 && this.defaultStagingLocation) {
                    this.stagingLocationOptions.push({
                        value: this.defaultStagingLocation,
                        text: 'MECCA SHIPPING DAMAGES'
                    });
                }
                
                if (this.dropLocationOptions.length === 0 && this.defaultDropLocation) {
                    this.dropLocationOptions.push({
                        value: this.defaultDropLocation,
                        text: `${this.orderingLocationName || 'Ordering Location'} DAMAGES`
                    });
                }
                
                console.log('Built location options:', {
                    source: this.sourceLocationOptions,
                    staging: this.stagingLocationOptions,
                    drop: this.dropLocationOptions
                });
            },
            
            disableFutureDates(date) {
                return date > new Date();
            },
            onReceivedDateChange(item, date) {
                console.log('Received date changed:', {
                    sku: item.product_sku,
                    newDate: date,
                    currentStatus: item.status
                });

                const today = moment().format('MM-DD-YYYY');
                if (date !== today) {
                    this.$bvToast.toast(
                        "Received date must be today's date",
                        {title: "Validation", autoHideDelay: 2000, variant:"warning"}
                    );
                    this.$set(item, 'received_date', today);
                    return;
                }

                if (date && item.status !== 'received') {
                    if (parseInt(item.quantity_received) === parseInt(item.quantity)) {
                        item.status = 'received';
                    } else {
                        this.$bvToast.toast(
                            "Cannot set received date: Received quantity must match damaged quantity",
                            {title: "Validation Error", autoHideDelay: 3000, variant:"warning"}
                        );
                        this.$set(item, 'received_date', null);
                    }
                }
            },
            applyMainScheduleDate() {
                if (!this.main_schedule_date) {
                    this.$bvToast.toast(
                        "No main schedule date available",
                        {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                this.schedule_date = this.main_schedule_date;

                let itemsUpdated = 0;
                this.items = this.items.map(item => {
                    if (item.original_status !== 'received' && !item.schedule_date) {
                        itemsUpdated++;
                        return {
                            ...item,
                            schedule_date: this.main_schedule_date,
                            has_external_schedule_date: true,
                            status: 'scheduled',
                            original_status: item.original_status || item.status
                        };
                    }
                    return item;
                });

                if (itemsUpdated > 0) {
                    this.$bvToast.toast(
                        `Main schedule date (${this.main_schedule_date}) applied to ${itemsUpdated} items. Status set to schedule.`,
                        {title: "Success", autoHideDelay: 2500, variant:"success"}
                    );
                } else {
                    this.$bvToast.toast(
                        "No items needed the main schedule date applied",
                        {title: "Info", autoHideDelay: 1500, variant:"info"}
                    );
                }

                this.$forceUpdate();
            },
            apply_date2: function(){
                if (this.schedule_date) {
                    let that = this;
                    this.items = this.items.map(function(d){
                        if (d.original_status !== 'received') {
                            d["schedule_date"] = that.schedule_date;
                            d["has_external_schedule_date"] = false;
                        }
                        return d;
                    });
                }
            },
            fetchAvailability(sku) {
                return new Promise((resolve, reject) => {
                    Requestor.getSyncP(
                        "/api/product/get_product_list_v4_damage_order/",
                        {
                            sku,
                            selling_location: this.selling_location
                        },
                        this
                    ).then(response => {
                        if (response.data.error) {
                            reject(response.data.error);
                            return;
                        }

                        const productData = (response.data.result && response.data.result[0]) || {};
                        resolve({
                            in_stock: productData.in_stock || 0,
                            reserved: productData.reserved || 0,
                            available: productData.available || 0
                        });
                    }).catch(error => {
                        console.error("Availability fetch failed:", error);
                        resolve({
                            in_stock: 0,
                            reserved: 0,
                            available: 0
                        });
                    });
                });
            },
            async fetchInventoryLocations(sku) {
                try {
                    const response = await new Promise((resolve, reject) => {
                        Requestor.getSyncP(
                            "/api/product/get_available_inventory_dropdown/",
                            { sku: sku, selling_location: this.selling_location },
                            this,
                            resolve,
                            reject
                        );
                    });

                    let responseData;
                    if (response && typeof response === 'object') {
                        if ('error' in response || 'result' in response) {
                            responseData = response;
                        }
                        else if (response.data && ('error' in response.data || 'result' in response.data)) {
                            responseData = response.data;
                        }
                    }

                    if (!responseData) {
                        console.error("Invalid API response format:", response);
                        return [];
                    }

                    if (responseData.error) {
                        console.error("API Error:", responseData.error);
                        return [];
                    }

                    return responseData.result || [];

                } catch (error) {
                    console.error("API call failed:", error);
                    return [];
                }
            },
            onQuantityInput(item) {
                const qty = parseInt(item.quantity, 10);
                if (isNaN(qty) || qty <= 0) {
                    this.$set(item, 'quantity', 0);
                    return;
                }

                this.$set(item, 'quantity', qty);
            },
            getImageSrc(image) {
                return image.raw || image.url || '';
            },
            handleImageUpload(event, item, idx) {
                const input = event.target;
                if (input.files && input.files[0]) {
                    const img = { raw: "", url: "", file: null };
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        img.raw = e.target.result;
                        if (!item.images) this.$set(item, 'images', []);
                        item.images.push(img);
                        this.$set(this.items, idx, item);
                    };

                    img.file = input.files[0];
                    reader.readAsDataURL(input.files[0]);
                }
            },
            removeImage(item, idx) {
                item.images = [];
                this.$refs['fileInput-' + idx][0].value = '';
                this.$set(this.items, idx, item);
            },
            showImagePreview(item) {
                if (!item.images || item.images.length === 0) return;

                this.$bvModal.msgBoxOk('', {
                    title: 'Damage Image Preview',
                    centered: true,
                    size: 'lg',
                    headerBgVariant: 'dark',
                    headerTextVariant: 'light',
                    bodyClass: 'text-center',
                    content: () => (
                        <div>
                            <img
                                src={this.getImageSrc(item.images[0])}
                                style="max-width: 100%; max-height: 70vh;"
                                alt="Damage Image"
                            />
                        </div>
                    )
                });
            },
            showExistingImagePreview(image, item) {
                this.$bvModal.msgBoxOk('', {
                    title: `Existing Damage Image - ${item.product_name}`,
                    centered: true,
                    size: 'lg',
                    headerBgVariant: 'dark',
                    headerTextVariant: 'light',
                    bodyClass: 'text-center',
                    content: () => (
                        <div>
                            <img
                                src={image.image_url}
                                style="max-width: 100%; max-height: 70vh;"
                                alt={image.image_alt_text || `Damage image for ${item.product_name}`}
                            />
                            {image.image_alt_text && (
                                <div style="margin-top: 10px; font-style: italic;">
                                    {image.image_alt_text}
                                </div>
                            )}
                        </div>
                    )
                });
            },
            handleImageError(event) {
                event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBmaWxsPSIjRjBGMEYwIi8+CjxwYXRoIGQ9Ik0yNiAxNEMyNiAxNS4xMDQ2IDI1LjEwNDYgMTYgMjQgMTZDMjIuODk1NCAxNiAyMiAxNS4xMDQ2IDIyIDE0QzIyIDEyLjg5NTQgMjIuODk1NCAxMiAyNCAxMkMyNS4xMDQ2IDEyIDI2IDEyLjg5NTQgMjYgMTRaIiBmaWxsPSIjQ0RDRENEIi8+CjxwYXRoIGQ9Ik0zMCAyNkMzMCAyNy4xMDQ2IDI5LjEwNDYgMjggMjggMjhIMTJDMTAuODk1NCAyOCAxMCAyNy4xMDQ2IDEwIDI2VjE0QzEwIDEyLjg5NTQgMTAuODk1NCAxMiAxMiAxMkgxNS4wM0wxNy4yMSA5Ljg3OTk5QzE3LjY3IDkuNDE5OTkgMTguMzMgOS4xOTk5OSAxOSA5LjE5OTk5SDIxQzIxLjY3IDkuMTk5OTkgMjIuMzMgOS40MTk5OSAyMi43OSA5Ljg3OTk5TDI0Ljk3IDEySDI4QzI5LjEwNDYgMTIgMzAgMTIuODk1NCAzMCAxNFYyNloiIGZpbGw9IiNDRENEQ0QiLz4KPC9zdmc+';
                event.target.onerror = null;
            },
            validateScheduledQuantity(item) {
                const min = 0;
                const max = item.quantity;

                this.$nextTick(() => {
                    if (item.quantity_scheduled < min) {
                        item.quantity_scheduled = min;
                    }
                    if (item.quantity_scheduled > max) {
                        item.quantity_scheduled = max;
                    }

                    if (item.quantity_scheduled > 0 && item.status !== 'received') {
                        if (item.status !== 'scheduled') {
                            item.status = 'scheduled';
                            if (!item.schedule_date) {
                                this.$set(item, 'schedule_date', moment().format('MM-DD-YYYY'));
                            }
                        }
                    } else if (item.quantity_scheduled === 0 && item.status === 'scheduled') {
                        item.status = 'submitted';
                    }
                });
            },
            onScheduleDateChange(item, date) {
                console.log('Schedule date changed:', {
                    sku: item.product_sku,
                    newDate: date,
                    currentStatus: item.status
                });

                if (date && item.has_external_schedule_date) {
                    item.has_external_schedule_date = false;
                }

                if (date && item.status !== 'received') {
                    this.$nextTick(() => {
                        if (item.quantity_scheduled > 0) {
                            item.status = 'scheduled';
                        }
                    });
                }

                if (!date && item.status === 'scheduled' && (!item.quantity_scheduled || item.quantity_scheduled <= 0)) {
                    this.$nextTick(() => {
                        item.status = 'submitted';
                    });
                }
            },
            onScheduledQuantityInput(item) {
                clearTimeout(this.scheduleValidationTimeout);
                this.scheduleValidationTimeout = setTimeout(() => {
                    this.validateScheduledQuantity(item);
                }, 300);
            },
            handleStatusChange(item) {
                console.log('Status changed for item:', item.product_sku, 'New status:', item.status);

                if (item.status === 'received') {
                    if (item.quantity_received !== item.quantity) {
                        this.$bvToast.toast(
                            `Cannot mark as COMPLETED: Received quantity (${item.quantity_received}) must equal damaged quantity (${item.quantity})`,
                            {title: "Validation Error", autoHideDelay: 3000, variant:"warning"}
                        );
                        this.$nextTick(() => {
                            item.status = item.original_status || 'submitted';
                        });
                        return;
                    }

                    this.$set(item, 'received_date', moment().format('MM-DD-YYYY'));
                    this.$set(item, 'quantity_received', item.quantity);
                }
                else if (item.status === 'scheduled') {
                    if (!item.schedule_date) {
                        this.$set(item, 'schedule_date', moment().format('MM-DD-YYYY'));
                    }

                    if (!item.quantity_scheduled || item.quantity_scheduled <= 0) {
                        this.$bvToast.toast(
                            "Cannot mark as scheduled: Scheduled quantity must be greater than 0",
                            {title: "Validation Error", autoHideDelay: 3000, variant:"warning"}
                        );
                        this.$nextTick(() => {
                            item.status = item.original_status || 'submitted';
                        });
                        return;
                    }
                }
                else if (item.status !== 'received' && item.received_date) {
                    this.$set(item, 'received_date', null);
                    this.$set(item, 'quantity_received', 0);
                }

                if (item.quantity_received > 0 && item.quantity_received < item.quantity) {
                    this.$nextTick(() => this.$set(item, 'status', 'partial'));
                }
            },
            validateQuantity(item) {
                if (item.status === 'received') {
                    item.quantity_received = item.quantity;
                    return;
                }

                const min = 0;
                const max = item.quantity;

                this.$nextTick(() => {
                    let received = Number(item.quantity_received) || 0;

                    if (received < min) {
                        received = min;
                    } else if (received > max) {
                        received = max;
                    }

                    item.quantity_received = received;

                    if (received === max) {
                        if (this.canChangeToCompleted(item)) {
                            item.status = 'received';
                            if (!item.received_date) {
                                item.received_date = moment().format('MM-DD-YYYY');
                            }
                        } else {
                            this.$bvToast.toast(
                                "Insufficient permissions to mark as COMPLETED",
                                {title: "Permission Error", autoHideDelay: 2000, variant:"warning"}
                            );
                            item.quantity_received = min;
                        }
                    } else if (received > 0) {
                        item.status = 'partial';
                    } else {
                        item.status = item.original_status || 'submitted';
                        item.received_date = null;
                    }
                });
            },
            canChangeToCompleted(item) {
                const allowedRoles = ['admin', 'officemanager', 'locationadmin'];
                return allowedRoles.includes(this.packet.userDetails.userrole);
            },
            getStatusState(item) {
                if (item.status === null || item.status === undefined || item.status === '') {
                    return false;
                } else {
                    if (item.quantity_received > 0) {
                        return ['received', 'partial'].includes(item.status) ? null : false;
                    }
                    return null;
                }
            },
            preventInvalidEntry(event, item) {
                const allowedKeys = [8, 9, 13, 37, 38, 39, 40, 46];
                if (allowedKeys.includes(event.keyCode)) return;

                const currentValue = event.target.value;
                const newValue = currentValue.slice(0, event.target.selectionStart) +
                                currentValue.slice(event.target.selectionEnd);

                const min = 0;
                const max = item.quantity;

                if (newValue !== '' && (isNaN(newValue) ||
                    parseInt(newValue) < min ||
                    parseInt(newValue) > max)) {
                    event.preventDefault();
                }
            },
          save_damage_order_items: function(){
    const invalidItems = this.items.filter(item => {
        if (item.status === 'received' && parseInt(item.quantity_received) !== parseInt(item.quantity)) {
            return true;
        }
        if (item.status === 'scheduled' && (!item.quantity_scheduled || parseInt(item.quantity_scheduled) <= 0)) {
            return true;
        }
        return false;
    });

    if (invalidItems.length > 0) {
        this.$bvToast.toast(
            "Cannot save: Some items have invalid status/quantity combinations",
            {title: "Validation Error", autoHideDelay: 3000, variant:"warning"}
        );
        return;
    }

    let data = {
        id: this.id,
        username: this.packet.userDetails.username,
        items: this.items.filter(item => item.original_status !== 'received').map(item => ({
            ...item,
            damaged_item_id: item.damaged_item_id // Make sure this is included
        })),
        schedule_date: this.schedule_date,
    }

    let that = this;
    let path = "/api/sales/save_damage_order_items/"
    let s = function(response) {
        if (response.data.error){
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
        } else {
            that.$bvToast.toast(
                "SAVED DAMAGE ITEMS",
                {title: "Success", autoHideDelay: 1500, variant:"success"}
            );
            that.fetchDamageOrderHistory();
            that.$emit("done-items-co", that.items);
        }
        that.loading = false
    }
    let f = function(error) {
        that.$bvToast.toast(
            "Error occurred. Please try again.",
            {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        that.loading = false
    }
    this.loading = true;
    Requestor.postSyncP(path, data, this, s, f);
},
            add_item: function(e) {
                if (this.items.some(item => item.damaged_item_id === e.damaged_item_id)) {
                    this.$bvToast.toast(
                        "Item already added to damage order",
                        {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                const vm = this;
                
                const newItem = {
                    id: null,
                    damaged_item_id: e.damaged_item_id,
                    product_sku: e.product_sku,
                    product_name: e.product_name,
                    product_id: e.product_id,
                    quantity: 1,
                    quantity_scheduled: 0,
                    quantity_received: 0,
                    original_price: e.wholesale_price || 0,
                    selling_price: 0,
                    cubes: e.cubes || 0,
                    // Set default locations directly
                    source_locsub: this.defaultItemLocation,
                    staging_location: this.defaultStagingLocation,
                    drop_location: this.defaultDropLocation,
                    damage_type: e.damage_type || 'Physical Damage',
                    damage_grade: e.damage_grade || 'Minor',
                    damage_description: e.damage_description || '',
                    status: 'ordered',
                    delivery_status: 0,
                    original_status: e.status || 'ordered',
                    in_stock: 0,
                    reserved: 0,
                    available: 0,
                    comments: '',
                    images: [],
                    existing_damage_images: e.damage_images || [],
                    has_external_schedule_date: false
                };

                console.log('Adding new item with default locations:', {
                    source: newItem.source_locsub,
                    staging: newItem.staging_location,
                    drop: newItem.drop_location
                });

                vm.items.push(newItem);
                vm.product_search_keyword = '';

                // Fetch availability data
                Requestor.getSyncP(
                    "/api/product/get_product_list_v4_damage_order/",
                    { sku: e.product_sku, selling_location: vm.selling_location },
                    vm,
                    function(response) {
                        if (response.data.error) {
                            console.error("Error fetching availability:", response.data.error);
                            return;
                        }

                        const productData = response.data.result && response.data.result[0];
                        if (productData) {
                            const itemIndex = vm.items.findIndex(item => item.damaged_item_id === e.damaged_item_id);
                            if (itemIndex !== -1) {
                                vm.$set(vm.items[itemIndex], 'in_stock', productData.in_stock || 0);
                                vm.$set(vm.items[itemIndex], 'reserved', productData.reserved || 0);
                                vm.$set(vm.items[itemIndex], 'available', productData.available || 0);
                            }
                        }
                    },
                    function(error) {
                        console.error("API call failed:", error);
                    }
                );
            },
            remove_item: function(item){
                if (!item.id){
                    this.items = this.items.filter(function(d){return d.damaged_item_id != item.damaged_item_id});
                } else {
                    let data = {
                        damage_order_id: this.id,
                        id: item.id,
                    }
                    let that = this;
                    let path = "/api/sales/delete_damage_order_item/"
                    let s = function(response) {
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        } else {
                            that.$bvToast.toast(
                                "DELETED ITEM",
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                            that.items = that.items.filter(function(d){return d.damaged_item_id != item.damaged_item_id});
                        }
                        that.loading = false
                    }
                    let f = function(error) {
                        that.$bvToast.toast(
                            "Error occurred. Please try again.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.loading = false
                    }
                    this.loading = true;
                    Requestor.getSyncP(path, data, this, s, f);
                }
            },
            filter_products: function(item, query){
                const queryLower = query.toLowerCase();
                return (
                    item.product_name.toLowerCase().indexOf(queryLower) > -1 ||
                    item.product_sku.toLowerCase().indexOf(queryLower) > -1 ||
                    item.damaged_item_id.toString().indexOf(queryLower) > -1 ||
                    (item.damage_type && item.damage_type.toLowerCase().indexOf(queryLower) > -1) ||
                    (item.damage_grade && item.damage_grade.toLowerCase().indexOf(queryLower) > -1)
                )
            },
            fetch_order_status: async function() {
                let data = {id: this.id}
                let path = "/api/sales/get_damage_order_status/"
                let that = this;
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    } else if (response.data.result && response.data.result.length > 0) {
                        that.order_status = response.data.result[0];
                    }
                }
                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching order status",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.getSyncP(path, data, this, s, f);
            },
            fetchDamageOrderHistory: function() {
                let data = {id: this.id}
                let path = "/api/sales/get_damage_order_history/"
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR RETRIEVING DAMAGE ORDER HISTORY",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    } else {
                        that.damageOrderHistory = response.data.result;
                    }
                    that.historyLoading = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH HISTORY. PLEASE TRY LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.historyLoading = false;
                }
                this.historyLoading = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            fetch_init: function() {
                if (!this.id) {
                    this.loading = false;
                    return;
                }

                let data = {id: this.id};
                let path = "/api/sales/get_damage_order_items/";
                let that = this;

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            "ERROR RETRIEVING DAMAGE ORDER ITEMS",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    } else {
                        that.processItems(response.data.result)
                            .then(() => {
                                that.loading = false;
                            })
                            .catch(error => {
                                that.loading = false;
                            });
                    }
                    that.loading = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED. PLEASE TRY AGAIN.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.loading = false;
                }
                this.loading = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            async processItems(items) {
                let vm = this;
                for (const item of items) {
                    if (item.status === 'received' && !item.received_date) {
                        this.$set(item, 'received_date', moment().format('MM-DD-YYYY'));
                        this.$set(item, 'quantity_received', item.quantity);
                    }

                    if (item.status) {
                        item.original_status = item.status;
                    }

                    item.has_external_schedule_date = false;
                    
                    // Add damaged_item_id if not present (for existing items)
                    if (!item.damaged_item_id) {
                        item.damaged_item_id = `temp_${item.id || Date.now()}`;
                    }

                    // If item doesn't have locations, set defaults
                    if (!item.source_locsub && this.defaultItemLocation) {
                        item.source_locsub = this.defaultItemLocation;
                    }
                    if (!item.staging_location && this.defaultStagingLocation) {
                        item.staging_location = this.defaultStagingLocation;
                    }
                    if (!item.drop_location && this.defaultDropLocation) {
                        item.drop_location = this.defaultDropLocation;
                    }

                    try {
                        const response = await new Promise((resolve, reject) => {
                            Requestor.getSyncP(
                                "/api/product/get_product_list_v4_damage_order/",
                                { sku: item.product_sku, selling_location: vm.selling_location },
                                this,
                                resolve,
                                reject
                            );
                        });

                        const responseData = response.data || response;
                        const productData = (responseData.result && responseData.result[0]) || {};

                        this.$set(item, 'in_stock', productData.in_stock || 0);
                        this.$set(item, 'reserved', productData.reserved || 0);
                        this.$set(item, 'available', productData.available || 0);

                    } catch (error) {
                        console.error("Error fetching availability for", item.product_sku, error);
                        this.$set(item, 'in_stock', 0);
                        this.$set(item, 'reserved', 0);
                        this.$set(item, 'available', 0);
                    }
                }

                this.items = items;
            },
           fetch_prereqs: function() {
    // Use selling_location instead of location_id
    let selling_location = this.viewdata.selling_location;
    
    if (!selling_location && !['admin', 'officemanager'].includes(this.packet.userDetails.userrole)) {
        // Fallback to user's location if selling_location is not provided
        selling_location = this.packet.userDetails.properties.location_id;
    }
    
    if (!selling_location) {
        this.$bvToast.toast(
            "Selling location information is required to load products",
            {title: "Warning", autoHideDelay: 1500, variant:"warning"}
        );
        this.loading = false;
        return;
    }

    this.selling_location = selling_location; // Store it for other uses

    let data = { selling_location: selling_location }; // Changed from location_id
    let path = "/api/sales/get_product_list_for_damage_order/";
    let that = this;

    this.loading = true;
    Requestor.getAsyncP(path, data, this,
        function(response) {
            if (response.data.error) {
                that.$bvToast.toast(
                    "ERROR RETRIEVING PRODUCT LIST",
                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                );
            } else {
                that.products = response.data.result || [];
            }
            that.loading = false;
        },
        function(error) {
            that.$bvToast.toast(
                "Error retrieving products.",
                {title: "Error", autoHideDelay: 1500, variant:"danger"}
            );
            that.loading = false;
        }
    );
},
            close_it: function(){
                this.$emit("done-items-co", this.items);
            }
        },
        computed: {
            allItemsHaveScheduleDate() {
                return this.items.length > 0 && this.items.every(item => item.schedule_date);
            },
            isAdmin() {
                return this.packet.userDetails.userrole === 'admin';
            },
            shouldDisableFields() {
                if (!this.order_status) return false;
                const restrictedStatuses = [2, 3, 4]; // IN-PROCESS(2), COMPLETED(3) and ARCHIVED(4)
                const isAdmin = this.packet.userDetails.userrole === 'admin';
                return restrictedStatuses.includes(this.order_status.status) && !isAdmin;
            },
            statusText() {
                return this.order_status ? this.status_mapping[this.order_status.status] : 'UNKNOWN';
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.id = this.viewdata.id;

            console.log('=== DAMAGE ORDER MODAL INITIALIZATION ===');
            console.log('Viewdata received:', this.viewdata);
            console.log('Packet locsubs available:', this.packet.locsubs ? this.packet.locsubs.length : 0);
            
            // First set default locations based on viewdata
            this.setDefaultLocations();

            // Set external dates from viewdata if available
            if (this.viewdata.schedule_date) {
                this.external_schedule_date = this.viewdata.schedule_date;
                this.schedule_date = this.viewdata.schedule_date;
            }
            if (this.viewdata.status) {
                this.external_status = this.viewdata.status;
            }

            try {
                if (this.viewdata.selling_location || this.packet.userDetails.properties.selling_location) {
                    this.fetch_prereqs();
                } else {
                    this.$bvToast.toast(
                        "Location information is required to load products",
                        {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                
                if (this.id) {
                    this.fetch_init();
                }
                
                // Fetch other data
                Promise.all([
                    this.fetch_order_status(),
                    this.fetchDamageOrderHistory()
                ]).catch(error => {
                    console.error("Initialization error:", error);
                });
            } catch (error) {
                console.error("Initialization error:", error);
                this.$bvToast.toast(
                    "Error loading damage order data",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
            }

            if (this.viewdata.schedule_date && this.order_status && this.order_status.status === 1) {
                this.schedule_date = this.viewdata.schedule_date;
                setTimeout(() => {
                    this.apply_date2();
                }, 100);
            }
            
            // Debug: Log what's in the packet
            setTimeout(() => {
                console.log('=== FINAL CHECK ===');
                console.log('Default Item Location:', this.defaultItemLocation);
                console.log('Default Staging Location:', this.defaultStagingLocation);
                console.log('Default Drop Location:', this.defaultDropLocation);
                console.log('Source Options:', this.sourceLocationOptions);
                console.log('Staging Options:', this.stagingLocationOptions);
                console.log('Drop Options:', this.dropLocationOptions);
            }, 1000);
        }
    }
</script>

<style scoped>
.input-field {
  width: 500px;
}
.diver{
  overflow:auto;
  width:100%;
}
th {background-color:white;}

table {
  table-layout: fixed;
  width:100%;
}

.srr {
    font-size: 11px;
    text-align: center;
    background: #efefef;
    border: 1px solid #010101;
    font-family: roboto;
}

.srrv {
    font-size: 11px;
    text-align: center;
    background: white;
    border: 1px solid #010101;
    padding: 5px;
    font-family: roboto;
}

.availability-table {
    width: 100%;
    font-size: 12px;
    border: 1px solid #dee2e6;
}

.availability-table th,
.availability-table td {
    padding: 4px 8px;
    border: 1px solid #dee2e6;
}

.availability-table thead th {
    background-color: #f8f9fa;
    font-weight: bold;
}

@media screen and (max-width: 768px) {
  .input-field {
    width: 100%;
  }
  .diver {
    height: auto;
    overflow-x: auto;
    overflow-y: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TransferOrders/DamageOrderModal.vue